import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/seed/siteContent";
import { Spinner } from "@/components/common/Primitives";

export default function AdminLoginPage() {
  const { signIn, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-maroon flex items-center justify-center" data-testid="admin-login-page">
        <Spinner className="py-24" />
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const result = await signIn(email.trim(), password);
    setSubmitting(false);
    if (result.ok) {
      navigate("/admin", { replace: true });
    } else {
      setError(result.error || "Invalid credentials");
    }
  }

  return (
    <div className="min-h-screen bg-maroon flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="BCS" className="h-16 w-16 rounded-full bg-white/95 p-1 mx-auto" />
          <h1 className="mt-4 font-serif text-2xl font-semibold text-white">BCS Admin Dashboard</h1>
          <p className="mt-1 text-sm text-white/60">Authorised administrators only</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-2xl p-8 space-y-5">
          <div>
            <label className="label-bcs" htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              className="input-bcs"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@bcsabha.org"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="label-bcs" htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              className="input-bcs"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </div>
          {error && (
            <p className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" className="btn-primary w-full" disabled={submitting} data-testid="admin-login-btn">
            <Lock size={15} /> {submitting ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-[11px] text-ink-muted text-center leading-relaxed">
            Access is restricted to BCS administrators. Public visitors do not need an account.
          </p>
        </form>
      </div>
    </div>
  );
}
